import { render } from "./IconMenu.vue?vue&type=template&id=577364ba&ts=true"
import script from "./IconMenu.vue?vue&type=script&lang=ts"
export * from "./IconMenu.vue?vue&type=script&lang=ts"

import "./IconMenu.vue?vue&type=style&index=0&id=577364ba&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__